import { useMemo } from 'react';

type JobsArray = Date[];

interface DayJobs {
  order: number;
  jobs: [JobsArray, JobsArray, JobsArray, JobsArray][];
}

const TIMELINE = [0, 1, 2, 3, 4, 5, 6];

function getSlotWithinHour(job: Date): number {
  const minutes = job.getMinutes();
  if (minutes < 15) {
    return 0;
  }
  if (minutes < 30) {
    return 1;
  }
  if (minutes < 45) {
    return 2;
  }

  return 3;
}

export function useGetDistributedCronJobs(cronJobs: Date[]): DayJobs[] {
  return useMemo(() => {
    const timeline: DayJobs[] = TIMELINE.map(dayId => ({
      order: dayId,
      jobs: new Array(24).fill(null).map(() => [[], [], [], []]),
    }));

    for (const cronJob of cronJobs) {
      const cronJobDay = cronJob.getDay();
      const cronJobHour = cronJob.getHours();
      const timelineDay = timeline[cronJobDay];
      const slotWithinHour = getSlotWithinHour(cronJob);
      const slot = timelineDay.jobs[cronJobHour][slotWithinHour];

      if (!slot.length) {
        slot.push(cronJob);
      }
    }

    const currentDay = new Date().getDay();
    // rotate the timeline so that the current day is at the beginning
    timeline.unshift(...timeline.splice(currentDay, 7));

    return timeline;
  }, [cronJobs]);
}
